// L'appli garde un travail de la personne (sans React, état du module ; porté de flowAI,
// src/lib/pwa-busy.ts). Les pages déclarent pourquoi il ne faut pas recharger maintenant :
// « selection » (pages choisies, pas encore envoyées), « file » (file d'envoi non vide),
// « envoi » (une requête d'envoi en cours, posée par le draineur) ; la barrière de version
// diffère son rechargement tant qu'une raison est active. Une raison est un drapeau, pas un
// compteur.

type Ecouteur = () => void

const raisons = new Set<string>()
const ecouteursInactivite = new Set<Ecouteur>()
const ecouteursChangement = new Set<Ecouteur>()

function prevenir(ecouteurs: Set<Ecouteur>) {
  // Copie : un écouteur peut se désabonner pendant l'appel.
  for (const e of [...ecouteurs]) {
    try {
      e()
    } catch {
      /* un écouteur fautif n'arrête pas les autres */
    }
  }
}

export function marquerOccupee(raison: string, occupee: boolean): void {
  const avait = raisons.has(raison)
  if (occupee === avait) return
  if (occupee) raisons.add(raison)
  else raisons.delete(raison)
  prevenir(ecouteursChangement)
  if (!occupee && raisons.size === 0) prevenir(ecouteursInactivite)
}

export function estOccupee(): boolean {
  return raisons.size > 0
}

export function raisonsOccupation(): string[] {
  return [...raisons]
}

/** Appelé chaque fois que la dernière raison se lève (pas à l'abonnement). */
export function surInactivite(e: Ecouteur): () => void {
  ecouteursInactivite.add(e)
  return () => void ecouteursInactivite.delete(e)
}

export function surChangementOccupation(e: Ecouteur): () => void {
  ecouteursChangement.add(e)
  return () => void ecouteursChangement.delete(e)
}

/** Durée pendant laquelle le travail de fond cède la place à un rechargement demandé. */
export const FENETRE_RECHARGEMENT_MS = 60_000
let fenetreJusqua = 0

/**
 * Demande au draineur de s'arrêter à sa prochaine frontière de tranche, pour qu'un rechargement
 * au-delà du plafond ait lieu entre deux envois. Limité dans le temps : sans rechargement, le
 * travail reprend seul.
 */
export function demanderFenetreRechargement(
  maintenant = Date.now(),
  duree = FENETRE_RECHARGEMENT_MS,
) {
  fenetreJusqua = Math.max(fenetreJusqua, maintenant + duree)
}

export function rechargementDemande(maintenant = Date.now()): boolean {
  return maintenant < fenetreJusqua
}

export function reinitialiserOccupationPourTests(): void {
  raisons.clear()
  ecouteursInactivite.clear()
  ecouteursChangement.clear()
  fenetreJusqua = 0
}
